import _Fab from './Fab';

import './style';

export * from './type';

export const Fab = _Fab;

export default Fab;
